import { CHAT_FILE_ACCEPT, CHAT_FILE_MAX_SIZE } from "@qw/chat";
import { FieldFileUpload, type FileUploadData } from "@qw/ui";
import type { FC } from "react";

export interface PlaybookFilesProps {
  canEdit: boolean;
  handleUploadFiles: (files: File[]) => Promise<FileUploadData[]>;
}

export const PlaybookFiles: FC<PlaybookFilesProps> = ({ canEdit, handleUploadFiles }) => (
  <FieldFileUpload
    label="Files"
    name="files"
    placeholder="Add PDF, Excel, or Word files to reference in your workflow (max 25MB)."
    accept={CHAT_FILE_ACCEPT}
    maxSize={CHAT_FILE_MAX_SIZE}
    onUploadFiles={handleUploadFiles}
    multiple
    disabled={!canEdit}
    readOnly={!canEdit}
  />
);
